/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_MenuInputs */



/**
* | output |
* | --- |
* | "New menu" |
*
* @param {New_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_menu = /** @type {((inputs?: New_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Menu nouveau")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Menü")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo menu")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новое меню")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo menú")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新メニュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया मेनू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo menu")
	return /** @type {LocalizedString} */ ("New menu")
});